// Hàm tạo ảnh khác nhau cho từng chuyên gia
export const getExpertImage = (expert) => {
  if (expert?.image) return expert.image;
  if (expert?.avatar) return expert.avatar;
  
  // Tạo ảnh dựa trên ID hoặc tên của chuyên gia
  const expertId = expert?.id || expert?._id || '';
  const expertName = expert?.name || expert?.displayName || expert?.fullName || '';
  
  // Danh sách ảnh avatar chuyên nghiệp cho chuyên gia
  const expertImages = [
    'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300&h=300&fit=crop&crop=face', // Bác sĩ nữ chuyên nghiệp 1
    'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=300&h=300&fit=crop&crop=face', // Bác sĩ nam chuyên nghiệp 1
    'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=300&h=300&fit=crop&crop=face', // Bác sĩ nam chuyên nghiệp 2
    'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=300&h=300&fit=crop&crop=face', // Bác sĩ nam chuyên nghiệp 3
    'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=300&h=300&fit=crop&crop=face', // Bác sĩ nữ chuyên nghiệp 2
    'https://images.unsplash.com/photo-1594824373631-0b0b3b3b3b3b?w=300&h=300&fit=crop&crop=face', // Bác sĩ nữ chuyên nghiệp 3
    'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=300&h=300&fit=crop&crop=face', // Bác sĩ nam chuyên nghiệp 4
    'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300&h=300&fit=crop&crop=face', // Bác sĩ nữ chuyên nghiệp 4
  ];
  
  // Tạo hash từ ID hoặc tên để chọn ảnh
  let hash = 0;
  const str = expertId + expertName;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  const imageIndex = Math.abs(hash) % expertImages.length;
  return expertImages[imageIndex];
};
